export function buildPublicSharedLinkView({
  document,
  pdfUrl,
  brandingRecord,
  user
}) {
  var _brandingRecord$logoA, _brandingRecord$logoU, _brandingRecord$prima, _brandingRecord$secon, _brandingRecord$showS;
  return {
    accessId: '',
    // Not needed for preview mode
    brandingMetadata: {
      logoAltText: (_brandingRecord$logoA = brandingRecord.logoAltText) !== null && _brandingRecord$logoA !== void 0 ? _brandingRecord$logoA : '',
      logoUrl: (_brandingRecord$logoU = brandingRecord.logoUrl) !== null && _brandingRecord$logoU !== void 0 ? _brandingRecord$logoU : undefined,
      primaryColor: (_brandingRecord$prima = brandingRecord.primaryColor) !== null && _brandingRecord$prima !== void 0 ? _brandingRecord$prima : undefined,
      secondaryColor: (_brandingRecord$secon = brandingRecord.secondaryColor) !== null && _brandingRecord$secon !== void 0 ? _brandingRecord$secon : undefined,
      showMarketingAd: false,
      showSalesAd: (_brandingRecord$showS = brandingRecord.showSalesAd) !== null && _brandingRecord$showS !== void 0 ? _brandingRecord$showS : false
    },
    hasActivity: false,
    hasDownload: true,
    id: document.id,
    name: document.title || document.originalFileName,
    pages: document.pages,
    pdfUrl: pdfUrl !== null && pdfUrl !== void 0 ? pdfUrl : undefined,
    shortLink: '',
    // Not needed for preview mode
    skipForm: true,
    user: {
      email: user.email,
      firstName: user.first_name,
      lastName: user.last_name
    },
    userId: 0 // Not needed for preview mode
  };
}